<template>
  <div class="bg-white">
    <v-container fluid style="padding-left: 3%; padding-right: 3%">
      <v-row class="justify-center">
        <v-col cols="12" sm="5" lg="3" xl="3" class="justify-center">
          <seller-info
            :loading="sellerInfo.loading"
            :errors="sellerInfo.errorMessage"
            :data="sellerInfo.data"
            class="h-100"
          />
        </v-col>

        <v-col cols="12" sm="7" lg="9" xl="9">
          <orders-table :chnl="user.VTWEG" />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="12">
          <v-card
            style="
              box-shadow: -1px 1px 7px 0px rgba(224, 37, 37, 0.45);
              -webkit-box-shadow: -1px 1px 7px 0px rgba(224, 37, 37, 0.45);
              -moz-box-shadow: -1px 1px 7px 0px rgba(224, 37, 37, 0.45);
            "
          >
            <v-card-text class="">
              <monthly-summary :chnl="user.VTWEG" class="w-100" />
              <hr />
              <backorders
                :seller="{
                  VTWEG: user.VTWEG,
                  PERNR: activeUsername?.username,
                }"
              />
            </v-card-text>
          </v-card>
          <fill-rate
            class="mt-3 w-100 pa-0"
            option="A"
            :chnl="user.VTWEG"
            :user-id="activeUsername?.username"
          />
          <customer-list
            :seller="{
              VTWEG: user.VTWEG,
              PERNR: activeUsername?.username,
              APPEN: seller?.append,
            }"
            :user="user"
            @desactiveLoader="finishCustomerList = true"
          />
        </v-col>
      </v-row>
      <confidentiality-notice />
    </v-container>
  </div>
</template>
<script
  src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.8.1/html2pdf.bundle.min.js"
  integrity="sha512-vDKWohFHe2vkVWXHp3tKvIxxXg0pJxeid5eo+UjdjME3DBFBn2F8yWOE0XmiFcFbXxrEOR1JriWEno5Ckpn15A=="
  crossorigin="anonymous"
  referrerpolicy="no-referrer"
></script>
<script>
  import ManagerPaymentHistory from './includes/modals/ManagerPaymentHistory.vue';
  import Backorders from './includes/Backorders.vue';
  import SellerInfo from './includes/SellerInfo.vue';
  import { mapGetters, mapActions } from 'vuex';
  import axios from '@/plugins/axios';
  import ordersTable from '@/views/daily/components/OrdersTable.vue';
  import moment from 'moment';
  import CustomerList from './includes/CustomerList.vue';
  import MonthlySummary from '@/views/daily/components/MonthlySummary.vue';
  import ConfidentialityNotice from '@/components/ConfidentialityNotice.vue';
  import FillRate from '@/views/fill_rate/FillRate.vue';
  import html2pdf from 'html2pdf.js';
  import MixinService from '@/mixins/service';
  import MixinDates from '@/mixins/dates';
  import loader from '@/mixins/loader';
  import activeUsernameMixin from '@/mixins/activeUsernameMixin';
  import { getGeneralInfo } from '@/repositories/Daily';

  export default {
    mixins: [MixinService, loader, MixinDates, activeUsernameMixin],
    name: 'SellerResults',
    components: {
      CustomerList,
      ConfidentialityNotice,
      ordersTable,
      MonthlySummary,
      SellerInfo,
      ManagerPaymentHistory,
      FillRate,
      Backorders,
    },
    created() {
      this.getSellerInfo();
    },
    computed: {
      ...mapGetters({
        authenticated: 'auth/authenticated',
        user: 'auth/user',
      }),
    },
    data: () => ({
      finishCustomerList: false,
      showModal: false,
      showManagerPaymentHistory: false,
      seller: {},
      sellerInfo: {
        data: {},
        loading: false,
        errorMessage: '',
      },
    }),
    watch: {
      finishCustomerList() {
        this.validateLoader();
      },
    },
    methods: {
      ...mapActions({
        sendToPDF: 'printer/sendToPDF',
        desactiveLoader: 'loader/desactiveLoader',
      }),
      validateLoader() {
        if (this.finishCustomerList) {
          this.desactiveLoader();
        }
      },
      monthDiff(dateFrom, dateTo) {
        return (
          dateTo.getMonth() -
          dateFrom.getMonth() +
          12 * (dateTo.getFullYear() - dateFrom.getFullYear())
        );
      },
      async getSellerInfo() {
        this.sellerInfo.loading = true;
        try {
          this.sellerInfo.data = await getGeneralInfo(
            this.activeUsername?.username,
            this.user.VTWEG
          );
          this.sellerInfo.data.seniority = this.countMonthsUpToToday(
            this.sellerInfo.data.seniority,
            'YYYY-MM-DD'
          ).text.text;
          this.sendToPDF({ active: true });
        } catch (error) {
          this.sellerInfo.errorMessage = `Hubo problemas al cargar la información del asesor`;
        }
        this.desactiveLoader();
        this.sellerInfo.loading = false;
      },
      showInfo() {
        this.showModal = true;
        this.showManagerPaymentHistory = true;
      },
      closeModal() {
        this.showModal = false;
        this.showManagerPaymentHistory = false;
      },
    },
    beforeRouteLeave(to, from, next) {
      next();
    },
  };
</script>
<style scoped src="../../../public/css/seller.css"></style>
